<template>
  <div>
    <KeyStyle ref="TextArea" :input-str="inputStr"></KeyStyle>
    <SimpleKeyboard
      ref="Keyboard"
      @onChange="onChange"
      @onKeyPress="onKeyPress"
      :input="input"
      :show-gesture="true"
      :next-input="nextKey"
    />
  </div>
</template>

<script>
import SimpleKeyboard from "../../SimpleKeyboard";
import KeyStyle from "../../StyleText/KeyStyle";
export default {
  name: "Word",
  components: {
    SimpleKeyboard,
    KeyStyle,
  },
  data: () => ({
    input: "",
    nextKey: "",
    inputStr:
      "They were very familiar with the sequencing keyboards: all their questions to the teacher were about music.", // 输入字符串
  }),
  created() {
    this.$nextTick(() => {
      this.nextKey = this.$refs.TextArea.nextKey();
    });
  },
  mounted() {
    this.$refs.Keyboard.compare = (btn) => {
      console.log("当前的", btn);

      if (btn === false) {
        return true;
      }
      var ch = this.$refs.TextArea.nextWord();
      this.nextKey = this.$refs.TextArea.nextKey();
      this.$refs.TextArea.removeKey(btn);

      return ch === btn;
    };
  },
  methods: {
    onChange(input) {
      this.input = input;
    },
    onKeyPress(button) {
      window.console.log("button", button);
    },
    onInputChange(input) {
      this.input = input.target.value;
    },
  },
};
</script>

<style lang="less" scoped></style>
